module.exports = __webpack_public_path__ + "static/media/horse-neighing.f6d1b3d1.png";